export default class BaseManager {
    constructor() {
    }

    init(adapter) {
        if (!adapter) {
            throw new Error('Adapter is not initialized (BaseManager)')
        }
        this.adapter = adapter
    }

    relaxConfigure(data) {

    }

    loadProgress(progress) {
    }

    insufficientFunds(){
    }

    loadCompleted() {
    }

    audioToggle(data) {
    }

    roundStart(value = 0) {
    }

    roundEnd({balance = 0, totalBet = 0, totalWin = 0}) {
    }

    featureStart() {
    }

    featureFinish() {
    }

    betUpdate(data) {
    }

    stakeUpdate(data) {
    }

    balanceUpdate(value) {
    }

    winUpdate(value) {
    }

    autoPlayStarted() {
    }

    autoplayFinished() {
    }

    closed() {
    }

    updateBalance() {
    }

    stopAutospins() {
    }

    setAudio(value) {
    }

    onShowOperatorHandlesErrors(errorResponse) {
    }

    showHelp() {
    }

    togglePaytable() {
    }

    errorMessage(data) {
    }

    goToDeposit() {
    }

    gameReload() {
    }
}
